import React from 'react'
import styled from 'styled-components'

import { DragIcon } from '@root/shared/ui-kit'

type TradeChartHandleProps = React.HTMLAttributes<HTMLDivElement>

export const TradeChartResizeHandle: React.FC<TradeChartHandleProps> = ({
  ...props
}) => {
  return (
    <Root {...props}>
      <Line>
        <DragIcon size={17} color="var(--text-10)" />
      </Line>
    </Root>
  )
}

const Line = styled.div`
  width: 100%;
  height: 1.5px;
  background: var(--background-3);
  transition: all 0.15s linear;
  position: relative;

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`

const Root = styled.div`
  position: relative;
  height: 3px;

  cursor: ns-resize;

  &:hover {
    ${Line} {
      transform: scaleY(1.5);
      background: var(--background-5);
    }
  }
`
